import { AloftPrice } from '@aloft/toolkit-shared';

import { Flex } from '../../../summary/components/Flex.js';
import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_COLUMN_WIDTHS } from '../constants.js';
import { sumPercentWidths } from '../utils/sumPercentWidths.js';

export const CostApproachSummarySiteValueRow = ({ siteValue }: { siteValue?: AloftPrice }) => (
  <Tr>
    <Td width={COST_APPROACH_COLUMN_WIDTHS[0]} isFirstColumn={true} isFirstRow={true}>
      <Typography variant="h4">Opinion of site value</Typography>
    </Td>
    <Td
      justifyContent="flex-end"
      colSpan={7}
      width={sumPercentWidths(...COST_APPROACH_COLUMN_WIDTHS.slice(1, 4))}
      isFirstRow={true}
    >
      <Flex justifyContent="flex-end">
        <Typography variant="h4" textAlign="right">
          {siteValue?.toString(true) ?? ''}
        </Typography>
      </Flex>
    </Td>
  </Tr>
);
